import { format } from "date-fns";

export const secondsToDays = (seconds?: number) => {
  if (seconds === undefined || Number.isNaN(seconds)) {
    return 0;
  }
  return seconds / 86400;
};

export const secondsToHours = (seconds?: number) => {
  if (seconds === undefined || Number.isNaN(seconds)) {
    return 0;
  }
  return seconds / 3600;
};

export const formatDuration = (seconds?: number) => {
  if (seconds === undefined || seconds === null) {
    return "-";
  }

  const abs = Math.max(0, Math.round(seconds));
  const days = Math.floor(abs / 86400);
  const hours = Math.floor((abs % 86400) / 3600);
  const minutes = Math.floor((abs % 3600) / 60);

  if (days > 0) {
    return `${days}d ${hours}h`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

export const formatShortDate = (value?: string) => {
  if (!value) {
    return "-";
  }
  return format(new Date(value), "yyyy-MM-dd");
};

export const formatDays = (value?: number) => {
  if (value === undefined || Number.isNaN(value)) {
    return "-";
  }
  return `${value.toFixed(2)}d`;
};

export const formatTimestampDate = (value?: number) => {
  if (value === undefined || Number.isNaN(value)) {
    return "-";
  }
  return format(new Date(value), "yyyy-MM-dd");
};

export const formatTimelineValue = (value: number) => {
  if (!Number.isFinite(value) || value <= 0) {
    return "0h";
  }
  if (value >= 24) {
    return `${(value / 24).toFixed(1)}d`;
  }
  return `${value.toFixed(1)}h`;
};
